import type { FilterGroup } from '@app/src/pages/ResourceCollection/Filters/useFilters'
import {
  ASSESSMENT_TEMPLATE_ID_PROP,
  INDUSTRY_INDEX_PROP,
  COUNTRY_INDEX_PROP,
  TOTAL_LEVEL_PROP,
  COUNTRY_RISK_PROP,
  INDUSTRY_RISK_PROP,
  SECTION_LEVEL_PROP,
} from '../hooks/getAssessmentFilterLabel'

export interface AutomationAssessmentValidationResult {
  isValid: boolean
  missingFields: string[]
}

export const validateAutomationAssessmentFilters = (
  categoryFilters: FilterGroup[],
): AutomationAssessmentValidationResult => {
  const missingFields: string[] = []

  // Find all relevant filters
  const assessmentTemplateFilter = categoryFilters.find(filter => filter.name === ASSESSMENT_TEMPLATE_ID_PROP)
  const totalLevelFilter = categoryFilters.find(filter => filter.name === TOTAL_LEVEL_PROP)
  const sectionLevelFilters = categoryFilters.filter(filter => filter.name.startsWith(SECTION_LEVEL_PROP))
  const countryIndexFilter = categoryFilters.find(filter => filter.name === COUNTRY_INDEX_PROP)
  const countryRiskFilter = categoryFilters.find(filter => filter.name === COUNTRY_RISK_PROP)
  const industryIndexFilter = categoryFilters.find(filter => filter.name === INDUSTRY_INDEX_PROP)
  const industryRiskFilter = categoryFilters.find(filter => filter.name === INDUSTRY_RISK_PROP)

  // Validate required assessment fields
  if (!assessmentTemplateFilter?.filters?.[0]?.value) {
    missingFields.push('assessmentTemplate')
  }

  // Require either total level OR section levels (not both)
  if (!totalLevelFilter?.filters?.[0]?.value && sectionLevelFilters.length === 0) {
    missingFields.push('totalLevel or sectionLevels')
  }

  // Validate risk filter dependencies
  if (countryIndexFilter?.filters?.[0]?.value && !countryRiskFilter?.filters?.[0]?.value) {
    missingFields.push('countryRiskStatus')
  }

  if (industryIndexFilter?.filters?.[0]?.value && !industryRiskFilter?.filters?.[0]?.value) {
    missingFields.push('industryRiskStatus')
  }

  return {
    isValid: missingFields.length === 0,
    missingFields,
  }
}
